import React, { useContext } from 'react';
import CountryFilter from '@modules/analysis/detail/headcountSalesByCountry/HeadcountSalesTable/CountryFilter';
import GridFilterContext from '@modules/analysis/detail/subsidiaries/grid/gridFilterContext';

function GridFilterDropdown({
  visible,
  confirm,
  filterKey,
  options,
  onSelectedKeyChange,
}) {
  const filters = useContext(GridFilterContext);

  return (
    <CountryFilter
      key={filterKey}
      allCountries={options || []}
      selectedKeys={filters[filterKey] || []}
      visible={visible}
      onSelectedKeyChange={(keys) => {
        onSelectedKeyChange(keys, filterKey);
        confirm();
      }}
      onCancel={confirm}
    />
  );
}

export default GridFilterDropdown;
